import { KeyboardTab } from "@mui/icons-material";
import {
  Box,
  BoxProps,
  Divider,
  Drawer,
  DrawerProps,
  IconButton,
  Stack,
  StackProps,
  styled,
} from "@mui/material";
import React from "react";

const BaseStyledDrawerContainer = ({
  py = 2,
  px = 3,
  ...rest
}: BoxProps) => {
  return <Box py={py} px={px} {...rest} />;
};

export const StyledDrawerContainer = styled(BaseStyledDrawerContainer)(({ theme }) => ({}));

const BaseStyledDrawerActions = ({
  direction = "row",
  spacing = 2,
  py = 2,
  px = 3,
  ...rest
}: StackProps) => {
  return <Stack direction={direction} spacing={spacing} py={py} px={px} {...rest} />;
};

export const StyledDrawerActions = styled(BaseStyledDrawerActions)(({ theme }) => ({}));

export const StyledDrawerTitle = styled(Box)(({ theme }) => ({
  flex: 1,
}));

interface IStyledDrawerProps extends DrawerProps {
  maxWidth?: number;
  hideDivider?: boolean;
}

function StyledDrawer({
  open,
  onClose,
  children,
  maxWidth,
  hideDivider,
  ...drawerProps
}: IStyledDrawerProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} {...drawerProps}>
      <Box sx={{ maxWidth: maxWidth || undefined, height: "100%" }}>
        {onClose && (
          <>
            <StyledDrawerContainer>
              <Stack direction="row" spacing={3} alignItems="center">
                <Box>
                  <IconButton
                    onClick={(e) => onClose && onClose(e, "backdropClick")}
                  >
                    <KeyboardTab />
                  </IconButton>
                </Box>

                {React.Children.toArray(children).filter((child) => {
                  if (!React.isValidElement(child)) {
                    return false;
                  }
                  return child.type === StyledDrawerTitle;
                })}
              </Stack>
            </StyledDrawerContainer>
            {!hideDivider && <Divider />}
          </>
        )}
        {React.Children.toArray(children).filter((child) => {
          if (!React.isValidElement(child)) {
            return false;
          }
          return child.type !== StyledDrawerTitle;
        })}
      </Box>
    </Drawer>
  );
}

export default StyledDrawer;
